import React from 'react';
import { Mutation } from 'react-apollo';

class DoMutation extends React.Component<any, any> {
  public componentDidMount() {
    const { mutate } = this.props;
    mutate();
  }

  public render() {
    return null;
  }
}

const MutationOnMount = (props: any) => {
  return (
    <Mutation {...props}>
      {(mutate, { data, loading, error }) => (
        <React.Fragment>
          <DoMutation mutate={mutate} />
          {props.children && props.children(mutate, { data, loading, error })}
        </React.Fragment>
      )}
    </Mutation>
  );
};

export default MutationOnMount;
